import { render } from "./TheBaoLucGiaDinh.vue?vue&type=template&id=63cf9334"
import script from "./TheBaoLucGiaDinh.vue?vue&type=script&lang=js"
export * from "./TheBaoLucGiaDinh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__